module.exports = __webpack_public_path__ + "img/goldregen-2020-038.cb44f3b8.jpg";